import styled from "styled-components";

import { ContainerCardMetrics } from "@Console/groups/[group_slug]/overview/components/atoms/CardMetrics/styles";

export const UserMetricsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 2rem 0 3rem 0;

  @media (max-width: 1000px) {
    gap: 1rem;
  }

  .teaching-user {
    margin-top: 2rem;
    @media (max-width: 1000px) {
      margin-top: 1.5rem;
    }
  }
`;

export const UserMetricsSectionCardsContainer = styled.div`
  h3 {
    font: 600 1rem "inter";
    color: ${({ theme }) => theme.console.pageSubtitleColor}!important;
  }
  overflow: hidden;
`;

export const UserMetricsSectionCardsContent = styled.div`
  margin-top: 1rem;
  display: flex;

  gap: 1.5rem;

  ${ContainerCardMetrics} {
    min-width: 12rem;
    width: 100%;
  }

  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;
